// // ProductBulkUpload.jsx
// import React, { useState } from "react";
// import * as XLSX from "xlsx";
// import "./ProductBulkUpload.css";
// import api from "../../api/baseUrl";
// import PrimaryButton from "../Button/primaryButton/PrimaryButton";
// import Snackbar from "../SnackBar/SnackBar";
// import SecondaryButton from "../SecondaryButton/SecondaryButton";
// import OutlineButton from "../Button/OutlineButton/OutlineButton";
// import UploadFileIcon from "../../icons/elements (1).svg"
// const ProductBulkUpload = ({ refreshDataProducts }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [previewData, setPreviewData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ message: "", type: "info" });

//   const toggleModal = () => {
//     setIsOpen(!isOpen);
//     if (!isOpen) {
//       setSelectedFile(null);
//       setPreviewData([]);
//     }
//   };

//   const handleFileChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     if (
//       file.type !==
//       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
//       !file.name.endsWith(".xlsx")
//     ) {
//       alert("فقط فایل Excel با پسوند .xlsx مجاز است");
//       return;
//     }

//     setSelectedFile(file);
//     setLoading(true);

//     try {
//       const data = await file.arrayBuffer();
//       const workbook = XLSX.read(data, { type: "array" });
//       const firstSheetName = workbook.SheetNames[0];
//       const firstSheet = workbook.Sheets[firstSheetName];

//       const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
//       const fiveCols = jsonData.map((row) => row.slice(0, 5));
//       setPreviewData(fiveCols);
//     } catch (err) {
//       console.error("خطا در خواندن اکسل:", err);
//       setSnackbar({ message: "خطا در خواندن فایل اکسل", type: "error" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleUpload = async () => {
//     if (!selectedFile) {
//       setSnackbar({ message: "ابتدا یک فایل انتخاب کنید", type: "error" });
//       return;
//     }
//     setLoading(true);
//     try {
//       const data = await selectedFile.arrayBuffer();
//       const workbook = XLSX.read(data, { type: "array" });
//       const firstSheetName = workbook.SheetNames[0];
//       const firstSheet = workbook.Sheets[firstSheetName];

//       const rawData = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
//       console.log("Raw Excel data:", rawData);

// for (const row of rawData) {
//   const productData = {
//     action: "add",
//     name: row["product_name"] || "",
//     brand: row["product_brand"] || "",
//     category: row["product_category"] || "",
//     price: row["product_price"] || 0,
//   };

//   // فقط اگر product_id موجود بود، اضافه کنیم
//   if (row["product_id"]) {
//     productData.id = row["product_id"];
//   }

//   console.log("Sending product:", productData);
//   await api.post("/crud-products", productData);
// }


//       refreshDataProducts()


//       toggleModal();
//     } catch (error) {
//       console.error("Error in sending data:", error);
//       setSnackbar({ message: "مشکل در ارسال داده‌ها به سرور", type: "error" });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleDownloadSample = () => {
//     const headers = [["product_price","product_brand", "product_category", "product_name", "product_id"]];
//     const worksheet = XLSX.utils.aoa_to_sheet(headers);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
//     XLSX.writeFile(workbook, "sample-products.xlsx");
//   };

//   return (
//     <>
//       <button className="export-btn" onClick={toggleModal}>
//         آپلود گروهی محصولات
//       </button>

//       {isOpen && (



//         // <div className="modal-overlay">
//         //   <div className="modal-content">
//         //     {/* <div className="modal-header">
//         //       <h2>پردازش محصولات</h2>

//         //        <button className="modal-close" onClick={toggleModal}>
//         //             ✕
//         //         </button>
//         //     </div> */}
//         //     <button className="modal-close" onClick={toggleModal}>
//         //             ✕
//         //         </button>

//         //     <div className="upload-box">
//         //       <div className="upload-dropzone">
//         //         <span className="upload-icon">📦</span>
//         //         <p>فایلتون رو اینجا بکشید و رها کنید</p>
//         //         <small>فرمت‌های مجاز: xlsx , xls , csv</small>
//         //         <label className="file-btn">
//         //           انتخاب فایل
//         //           <input
//         //             type="file"
//         //             accept=".xlsx,.xls,.csv"
//         //             onChange={handleFileChange}
//         //             hidden
//         //           />
//         //         </label>
//         //       </div>
//         //     </div>

//         //     {loading && <p>در حال پردازش...</p>}

//         //     {previewData.length > 0 && (
//         //       <div className="preview-table">
//         //         <h3>پیش‌نمایش فایل</h3>
//         //         <table>
//         //           <tbody>
//         //             {previewData.map((row, idx) => (
//         //               <tr key={idx}>
//         //                 {row.map((cell, cIdx) => (
//         //                   <td key={cIdx}>{cell}</td>
//         //                 ))}
//         //               </tr>
//         //             ))}
//         //           </tbody>
//         //         </table>
//         //       </div>
//         //     )}

//         //     <p className="hint">ستون‌ها باید شامل برند، دسته‌بندی، نام محصول و قیمت باشند.</p>

//         //     <div className="modal-actions">
//         //       <button className="sample-btn " onClick={handleDownloadSample}>
//         //         دانلود فایل نمونه
//         //       </button>
//         //       <div className="action-buttons">
//         //         <button onClick={toggleModal} className="cancel-btn">
//         //           انصراف
//         //         </button>

//         //         <PrimaryButton
//         //           title="ادامه"
//         //           loading={loading}
//         //           onClick={handleUpload}
//         //         />
//         //       </div>
//         //     </div>
//         //   </div>

//         //   <Snackbar
//         //     message={snackbar.message}
//         //     type={snackbar.type}
//         //     duration={3000}
//         //     toggleModal={() => setSnackbar({ message: "", type: "info" })}
//         //   />
//         // </div>

//         <div className="modal-overlay" onClick={toggleModal}>
//           <div
//             className="modal"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button className="modal-close" onClick={toggleModal}>
//               ✕
//             </button>
//             <h2 className="modal-title">پردازش محصولات</h2>

//             <div className="upload-box">
//               <div className="upload-dropzone">
//                 <span className="upload-icon"><img src={UploadFileIcon} /></span>
//                 <p>فایلتون رو اینجا بکشید و رها کنید</p>

//                 <small className="upload-hint">فرمت‌های مجاز: xlsx , xls , csv</small>

//                 <label className="file-btn">
//                   انتخاب فایل
//                   <input
//                     type="file"
//                     accept=".xlsx,.xls,.csv"
//                     onChange={handleFileChange}
//                     hidden
//                   />
//                 </label>
//               </div>
//             </div>


//             {loading && <p>در حال پردازش...</p>}

//             {previewData.length > 0 && (
//               <div className="preview-table">
//                 <h3>پیش‌نمایش فایل</h3>
//                 <table>
//                   <tbody>
//                     {previewData.map((row, idx) => (
//                       <tr key={idx}>
//                         {row.map((cell, cIdx) => (
//                           <td key={cIdx}>{cell}</td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}

//             <p className="hint">ستون‌ها باید شامل برند، دسته‌بندی، نام محصول و قیمت باشند.</p>

//             <div className="modal-actions">
//               {/* <button className="sample-btn " onClick={handleDownloadSample}>
//                 دانلود فایل نمونه
//               </button> */}


//               <OutlineButton title="دانلود نمونه فایل" onClick={handleDownloadSample} />



//               <div className="action-buttons">
//                 {/* <button onClick={toggleModal} className="cancel-btn">
//                   انصراف
//                 </button> */}

//                 <SecondaryButton title="انصراف" onClick={toggleModal} />


//                 <PrimaryButton
//                   title="ادامه"
//                   loading={loading}
//                   onClick={handleUpload}
//                 />
//               </div>
//             </div>            </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ProductBulkUpload;
// ProductBulkUpload.jsx
import React, { useState } from "react";
import * as XLSX from "xlsx";
import "./ProductBulkUpload.css";
import api from "../../api/baseUrl";
import PrimaryButton from "../Button/primaryButton/PrimaryButton";
import Snackbar from "../SnackBar/SnackBar";
import SecondaryButton from "../SecondaryButton/SecondaryButton";
import OutlineButton from "../Button/OutlineButton/OutlineButton";
import UploadFileIcon from "../../icons/elements (1).svg";

const ProductBulkUpload = ({ refreshDataProducts }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewData, setPreviewData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ message: "", type: "info" });

  const [failedProducts, setFailedProducts] = useState([]);
  const [showFailedModal, setShowFailedModal] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
    if (!isOpen) {
      setSelectedFile(null);
      setPreviewData([]);
    }
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (
      file.type !==
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
      !file.name.endsWith(".xlsx")
    ) {
      alert("فقط فایل Excel با پسوند .xlsx مجاز است");
      return;
    }

    setSelectedFile(file);
    setLoading(true);

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const firstSheet = workbook.Sheets[firstSheetName];

      const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });
      const fiveCols = jsonData.map((row) => row.slice(0, 5));
      setPreviewData(fiveCols);
    } catch (err) {
      console.error("خطا در خواندن اکسل:", err);
      setSnackbar({ message: "خطا در خواندن فایل اکسل", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setSnackbar({ message: "ابتدا یک فایل انتخاب کنید", type: "error" });
      return;
    }
    setLoading(true);
    setFailedProducts([]);

    try {
      const data = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const firstSheet = workbook.Sheets[firstSheetName];

      const rawData = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });
      const failed = [];
      const batchSize = 50; // ارسال دسته‌ای

      for (let i = 0; i < rawData.length; i += batchSize) {
        const batch = rawData.slice(i, i + batchSize);

        await Promise.all(
          batch.map(async (row) => {
            const productData = {
              action: "add",
              name: row["product_name"] || "",
              brand: row["product_brand"] || "",
              category: row["product_category"] || "",
              price: row["product_price"] || 0,
            };
            if (row["product_id"]) productData.id = row["product_id"];

            // بررسی خالی بودن ستون‌های ضروری
            if (!productData.name || !productData.brand || !productData.category || productData.price === "") {
              failed.push({ ...productData, error: "ستون‌های ضروری خالی است" });
              return;
            }

            try {
              await api.post("/crud-products", productData);
            } catch (err) {
              failed.push({ ...productData, error: err.message });
            }
          })
        );
      }

    // نمایش خطاها اگر وجود داشته باشد
    if (failed.length > 0) {
      setFailedProducts(failed);
      setShowFailedModal(true);
    } else {
      // فقط اگر خطایی نبود، مودال بسته شود
      toggleModal();
      setSnackbar({ message: "محصولات با موفقیت اضافه شدند", type: "success" });
    }
      // دریافت همه محصولات با صفحه‌بندی
      let allProducts = [];
      let page = 1;
      let pagesCount = 1;

      do {
        const { messages, pagesCount: pc } = await refreshDataProducts(page);
        allProducts = [...allProducts, ...messages];
        pagesCount = pc;
        page++;
      } while (page <= pagesCount);

      // toggleModal();
    } catch (error) {
      console.error("Error in sending data:", error);
      setSnackbar({ message: "مشکل در ارسال داده‌ها به سرور", type: "error" });
    } finally {
      setLoading(false);
    }
  };


  const handleDownloadSample = () => {
    const headers = [["product_price", "product_brand", "product_category", "product_name", "product_id"]];
    const worksheet = XLSX.utils.aoa_to_sheet(headers);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sample");
    XLSX.writeFile(workbook, "sample-products.xlsx");
  };


  const handleDownloadFailed = () => {
    if (failedProducts.length === 0) return;

    // ستون‌ها برای فایل اکسل
    const headers = [["product_name", "product_brand", "product_category", "product_price", "error"]];

    // داده‌ها
    const rows = failedProducts.map(p => [
      p.name,
      p.brand,
      p.category,
      p.price,
      p.error
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "FailedProducts");

    XLSX.writeFile(workbook, "failed-products.xlsx");
  };

  return (
    <>
      <button className="export-btn" onClick={toggleModal}>
        آپلود گروهی محصولات
      </button>

      {/* مودال اصلی */}
      {isOpen && (
        <div className="modal-overlay" onClick={toggleModal}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={toggleModal}>✕</button>
            <h2 className="modal-title">پردازش محصولات</h2>

            <div className="upload-box">
              <div className="upload-dropzone">
                <span className="upload-icon">
                  <img src={UploadFileIcon} alt="upload icon" />
                </span>
                <p>فایلتون رو اینجا بکشید و رها کنید</p>
                <small className="upload-hint">فرمت‌های مجاز: xlsx , xls , csv</small>
                <label className="file-btn">
                  انتخاب فایل
                  <input
                    type="file"
                    accept=".xlsx,.xls,.csv"
                    onChange={handleFileChange}
                    hidden
                  />
                </label>
              </div>
            </div>

            {loading && <p>در حال پردازش...</p>}

            {previewData.length > 0 && (
              <div className="preview-table">
                <h3>پیش‌نمایش فایل</h3>
                <table>
                  <tbody>
                    {previewData.map((row, idx) => (
                      <tr key={idx}>
                        {row.map((cell, cIdx) => (
                          <td key={cIdx}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <p className="hint">ستون‌ها باید شامل برند، دسته‌بندی، نام محصول و قیمت باشند.</p>

            <div className="modal-actions">
              <OutlineButton title="دانلود نمونه فایل" onClick={handleDownloadSample} />
              <div className="action-buttons">
                <SecondaryButton title="انصراف" onClick={toggleModal} />
                <PrimaryButton title="ادامه" loading={loading} onClick={handleUpload} />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* مودال محصولات خطادار */}
      {showFailedModal && (
        <div className="modal-overlay" onClick={() => setShowFailedModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowFailedModal(false)}>✕</button>
            <h2 className="modal-title">محصولات با خطا</h2>
            <table className="failed-products-table">
              <thead>
                <tr>
                  <th>نام محصول</th>
                  <th>برند</th>
                  <th>دسته‌بندی</th>
                  <th>قیمت</th>
                  <th>خطا</th>
                </tr>
              </thead>
              <tbody>
                {failedProducts.map((p, idx) => (
                  <tr key={idx}>
                    <td>{p.name}</td>
                    <td>{p.brand}</td>
                    <td>{p.category}</td>
                    <td>{p.price}</td>
                    <td>{p.error}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="modal-actions">
              <SecondaryButton title="انصراف" onClick={() => setShowFailedModal(false)} />
              <PrimaryButton title="دانلود فایل خطاها" onClick={handleDownloadFailed} />


            </div>


          </div>
        </div>
      )}

      {/* Snackbar */}
      <Snackbar
        message={snackbar.message}
        type={snackbar.type}
        duration={3000}
        toggleModal={() => setSnackbar({ message: "", type: "info" })}
      />
    </>
  );
};

export default ProductBulkUpload;
